import type {
  AdminPortalUser,
  DealerListItem,
  DealerProfileUpdateInput,
  DealerPortalUser,
  DealerRegistrationInput,
} from '@/lib/domain';
import { apiGet, apiSend } from '@/lib/api/client';

interface DealerLoginResult {
  dealer: DealerPortalUser;
}

interface AdminLoginResult {
  admin: AdminPortalUser;
}

export async function registerDealer(input: DealerRegistrationInput) {
  return apiSend<{ message?: string }>('/auth/register.php', 'POST', input);
}

export async function fetchCurrentDealerProfile() {
  return apiGet<DealerPortalUser | null>('/auth/me.php?portal=dealer');
}

export async function fetchCurrentAdminProfile() {
  return apiGet<AdminPortalUser | null>('/auth/me.php?portal=admin');
}

export async function signInDealer(email: string, password: string) {
  return apiSend<DealerLoginResult>('/auth/login.php', 'POST', {
    email,
    password,
    portal: 'dealer',
  });
}

export async function signInAdmin(email: string, password: string) {
  return apiSend<AdminLoginResult>('/auth/login.php', 'POST', {
    email,
    password,
    portal: 'admin',
  });
}

export async function signOutCurrentUser() {
  return apiSend<null>('/auth/logout.php', 'POST');
}

export async function updateDealerProfile(input: DealerProfileUpdateInput) {
  return apiSend<DealerPortalUser>('/dealer/profile.php', 'PUT', input);
}

export async function updateCurrentUserPassword(newPassword: string) {
  return apiSend<null>('/auth/change-password.php', 'POST', { newPassword });
}

export async function sendPasswordReset(email: string) {
  return apiSend<{ message?: string }>('/auth/request-reset.php', 'POST', { email });
}

export async function resetPasswordWithToken(token: string, newPassword: string) {
  return apiSend<null>('/auth/reset-password.php', 'POST', { token, newPassword });
}

export async function fetchDealers(): Promise<DealerListItem[]> {
  return apiGet<DealerListItem[]>('/admin/dealers.php');
}

export async function updateDealerAdminFields(
  dealerId: string,
  updates: Partial<Pick<DealerPortalUser, 'approved' | 'portalAccess'>> & { notes?: string },
) {
  return apiSend<DealerListItem>('/admin/dealers.php', 'PATCH', {
    dealerId,
    ...updates,
  });
}

export async function fetchAdminAccounts(): Promise<AdminPortalUser[]> {
  return apiGet<AdminPortalUser[]>('/admin/accounts.php');
}
